import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    REVOKE_PROXIES_FAILURE,
    REVOKE_PROXIES_SUCCESS,
} from 'src/pages/more/pages/proxies/redux/action/actionTypes.js';
import { revokeProxiesService } from 'src/pages/more/pages/proxies/redux/services/index.js';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* revokeProxies(action) {
    try {
        const result = yield revokeProxiesService(action.payload);
        yield put({ type: REVOKE_PROXIES_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/${action.payload}`,
            requestPayload: action.payload,
        });
        yield put({
            type: REVOKE_PROXIES_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
